<template>
    <Breadcrumbs main="Jobs" mains="Jobs" title="Paramètres" />
    <div class="container-fluid">
        <div class="row">
            <JobList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const JobList = defineAsyncComponent(
    () => import('@/components/theme/jobs/JobList.vue'),
);
</script>
